import {AfterContentChecked, AfterViewInit, Component, HostListener} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { AuthenticationService } from './services/authentication.service';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import {ZendescService} from './services/zendesc.service';
import { ElementQueries } from 'css-element-queries';

declare const toastr: any;
declare const googletag: any;
declare const $: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements AfterContentChecked, AfterViewInit {

    private isProd: boolean = Boolean(environment.production);
    private baseHost = '';
    private overflowToastShowed: boolean;

    constructor(private router: Router, private authentication: AuthenticationService, private zd: ZendescService) {
        zd.initScript();
        this.baseHost = window.location.origin;
        this.routeNavigation();
        toastr.options = {
            closeButton: true,
            debug: false,
            // progressBar: true,
            preventDuplicates: true,
            positionClass: 'toast-top-right',
            onclick: null,
            showDuration: '400',
            hideDuration: '1000',
            timeOut: '7000',
            extendedTimeOut: '1000',
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut'
        };
    }

    ngAfterContentChecked() {
        this.onResize();

    }

    private routeNavigation(): void {
        let previsionPage = null;
        this.router.events
            .pipe(
                debounceTime(500),
                filter(event => event instanceof NavigationEnd),
                switchMap((event: NavigationEnd) => {
                    const subs$ = [
                        this.trackVisit(event.urlAfterRedirects, previsionPage),
                        this.sendActivityUser()
                    ];
                    previsionPage = event.urlAfterRedirects;
                    return Observable.forkJoin(...subs$);
                }),
            )
            .subscribe();
    }

    private sendActivityUser(): Observable<any> {
        return this.authentication.sendActivityUser();
    }

    private trackVisit(page, prevPage): Observable<any> {
        const email = '';
        if (this.isProd) {
            const currentUrl = this.baseHost + page;
            const prevUrl = prevPage ? this.baseHost + prevPage : prevPage;
            const url = '//trackcmp.net/visit?actid=223808493&e=' + encodeURIComponent(email) + '&r=' + encodeURIComponent(prevUrl) + '&u=' + encodeURIComponent(currentUrl);
            const img = new Image();
            img.src = url;
        }
        return Observable.of(page);
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        const table = $('.table-responsive');
        if (table.length) {
            const element = table[0];
            if (element.offsetWidth < element.scrollWidth && !this.overflowToastShowed) {
                if (!this.authentication.userIsResident) {
                    this.overflowToastShowed = true;
                    toastr.warning('We would recomend you to zoomout your viewport to avoid horizontal scrolling');
                }
            }
        }

        const doc = document.documentElement
        let vh = window.innerHeight * 0.01;
        doc.style.setProperty('--app-height', `${vh}px`);
    }

    ngAfterViewInit() {
        ElementQueries.listen();
        ElementQueries.init();
    }
}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts